import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { Input, Radio, Checkbox } from 'semantic-ui-react'
import { withSystemConfig, colors } from 'shared'
//@ts-ignore
import LKButton from 'shared/LKButton'
import { LKButton as LKBaseButton } from 'loankeeper-common/components'
//@ts-ignore
import LKPrintButton, { constants as LKPrintButtonConstants } from 'shared/LKPrintButton'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
//@ts-ignore
import LKGridExportButton from 'shared/LKGrid/ExportButton'
import translate, { translateTransactions } from '../../translator'
import { pages } from './constants'
import { actions as DCActions } from '../../../DetailsContainer'
import LoanDisburseNoAccModal, { LoanDisburseNoAccTrigger } from '../../../LoanDisburseNoAcc'

import { OperationsProps } from '../../types.LoanDetails'

const DLConfig = {
  gridIdentity: {
    formName: 'frm_loan_view',
    objectName: 'grd_operations',
  },

  syncGridState: true,
  selectLastRow: true,
  enableColumnsOrder: true,
  enableColumnsResize: true,
  enableColumnsHide: true,
  enableRowSelection: true,
  showCellFocus: true,

  getRowStyle: ({
    node: {
      data: { OverdueDays },
    },
  }) => (OverdueDays ? { color: colors.red } : {}),

  columnConfigs: {
    OperDate: { valueFormatter: ({ value }) => LKDate.from(value).toString() },
    ProcedureFee: { valueFormatter: ({ value }) => value.toFixed(2), cellStyle: { textAlign: 'right' } },
    Principal: { valueFormatter: ({ value }) => value.toFixed(2), cellStyle: { textAlign: 'right' } },
    Disburse: { valueFormatter: ({ value }) => value.toFixed(2), cellStyle: { textAlign: 'right' } },
    Interest: { valueFormatter: ({ value }) => value.toFixed(2), cellStyle: { textAlign: 'right' } },
    Penalty_Principal: { valueFormatter: ({ value }) => value.toFixed(2), cellStyle: { textAlign: 'right' } },
    Penalty_Interest: { valueFormatter: ({ value }) => value.toFixed(2), cellStyle: { textAlign: 'right' } },
    Advanced_Fee: { valueFormatter: ({ value }) => value.toFixed(2), cellStyle: { textAlign: 'right' } },
    UCLC: { valueFormatter: ({ value }) => value.toFixed(2), cellStyle: { textAlign: 'right' } },
    Correction_Interest: { valueFormatter: ({ value }) => value.toFixed(2), cellStyle: { textAlign: 'right' } },
    Correction_Penalty_Principal: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },
    Correction_Penalty_Interest: { valueFormatter: ({ value }) => value.toFixed(2), cellStyle: { textAlign: 'right' } },
    Correction_UCLC: { valueFormatter: ({ value }) => value.toFixed(2), cellStyle: { textAlign: 'right' } },
    Correction_ProcFee: { valueFormatter: ({ value }) => value.toFixed(2), cellStyle: { textAlign: 'right' } },
    OSBalance: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right', fontWeight: 'bold' },
    },
    TotalCover: { valueFormatter: ({ value }) => value.toFixed(2), cellStyle: { textAlign: 'right' } },
    PassedDays: { cellStyle: { textAlign: 'right' } },
    OverdueDays: { cellStyle: { textAlign: 'right' } },
  },
  getContextMenuItems: () => ['excelExport'],
}

@withRouter
@withSystemConfig('AccEnabled')
//@ts-ignore
@connect(
  undefined,
  (
    dispatch,
    {
      //@ts-ignore
      match: {
        params: { ID, hash },
      },
      //@ts-ignore
      fetchOperations,
    },
  ) => ({
    fetchAll: () => {
      dispatch(fetchOperations())
      dispatch(DCActions.fetchPage({ type: 'Loan', ID, hash, page: 'transactions' }))
      dispatch(DCActions.fetchPage({ type: 'Loan', ID, hash, page: 'base' }))
    },
  }),
)
class Operations extends React.Component<OperationsProps> {
  static defaultProps = {
    data: [],
  }

  state = {
    sum: '0',
  }

  calculateSum = ({ value }: { value: number }, { columnData }: { columnData: number[] }) => {
    if (!isNaN(value)) {
      this.setState({ sum: columnData.reduce((result, a) => result + a, 0).toFixed(2) })
    }
  }

  sumColumns = (sum: string) => {
    this.setState({ sum })
  }

  handleNominalChange = (_e, { checked, value }: { checked: boolean; value: number }) => {
    const { changeNominalFlag, activeOperationsFlag } = this.props

    if (checked) {
      changeNominalFlag(value, activeOperationsFlag)
    }
  }

  handleActiveOperationsFlagChange = (_e, { checked }: { checked: boolean }) => {
    const { changeActiveOperationsFlag, nominalFlag } = this.props

    changeActiveOperationsFlag(checked ? 1 : 2, nominalFlag)
  }

  handleDisburse = () => {
    this.props.fetchAll()
  }

  render() {
    const {
      instanceName,
      data,
      base,
      switchPage,
      nominalFlag,
      activeOperationsFlag,
      match: { params },
    } = this.props

    return (
      <div className="u-flex u-fluid u-directionColumn">
        <div className="u-fluid u-relative">
          <LKGrid instanceName={instanceName} rowData={data} onCellClicked={this.calculateSum} {...DLConfig} />
        </div>

        <div className="u-padding-5 u-flex">
          <LKBaseButton alias="sum" />
          <Input value={this.state.sum} />
        </div>

        <hr style={{ margin: 0 }} />

        {/* actions */}
        <div className="u-flex u-padding-5">
          {this.props.AccEnabled === '1' && (
            <LKButton alias="transactions" onClick={() => switchPage(pages.transactions)}>
              {translate('cmd_transaction')}
            </LKButton>
          )}
          <div className="u-fluid u-flex u-alignCenter u-marginLeft-15">
            <Radio
              label={translate('opt_turnover_nominal')}
              value={1}
              checked={nominalFlag === 1}
              onChange={this.handleNominalChange}
            />

            <Radio
              label={translate('opt_turnover_local')}
              value={2}
              checked={nominalFlag === 2}
              onChange={this.handleNominalChange}
              style={{ marginLeft: 30 }}
            />

            <Checkbox
              label={translate('chk_brief')}
              checked={activeOperationsFlag === 1}
              onChange={this.handleActiveOperationsFlagChange}
              style={{ marginLeft: 30 }}
            />
          </div>

          {base.IsArrested !== 1 && (
            <div>
              {this.props.AccEnabled !== '1' && (
                <>
                  <LoanDisburseNoAccModal onSuccess={this.handleDisburse} />

                  <LoanDisburseNoAccTrigger
                    params={{
                      ID: params.ID,
                      hash: params.hash,
                      FullName: base.FullName,
                      clientID: base.ClientID,
                      clientHash: base.HashSum_ClientID_,
                    }}
                  >
                    {translateTransactions('cmd_disburse')}
                  </LoanDisburseNoAccTrigger>

                  <LKButton alias="cover">{translateTransactions('cmd_cover')}</LKButton>
                </>
              )}

              <LKPrintButton
                type={LKPrintButtonConstants.types.loan}
                upward
                name={translate('cmd_print_order')}
                ID={params.ID}
                hash={params.hash}
                page="printloanorder"
              />

              <LKPrintButton
                type={LKPrintButtonConstants.types.loan}
                upward
                leftward
                name={translate('cmd_print_turnover')}
                ID={params.ID}
                hash={params.hash}
                page="printloanturnover"
              />

              <LKGridExportButton alias="export" size="tiny" instanceName={instanceName} />
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default Operations
